import {
    BuyFin,
    Financeit,
    GoodLeap,
    GreenSky,
    ServiceFinance,
    Synchrony,
    WellsFargo,
} from '@servicetitan/financing-provider-assets';
import { SetupDataStore } from '@servicetitan/financing-workflow-shared';
import { providerIdToName } from '@servicetitan/financing-utils-shared';

export const AutoProviderLogo = () => {
    const logos: { [k: string]: string } = {
        BuyFin,
        Financeit,
        GoodLeap,
        GreenSky,
        ServiceFinance,
        Synchrony,
        WellsFargo,
    };
    const { setupData } = SetupDataStore.useStore();

    if (setupData == null) {
        return null;
    }

    return (
        <img
            src={logos[setupData.provider]}
            alt={`Logo for ${providerIdToName(setupData.provider)}`}
            style={{ width: 140, margin: '0 auto' }}
        />
    );
};
